import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { PluginProps } from '../Plugin';
const PromptContainer = React.lazy(
  () => import('../../../../ai/PromptContainer'),
);
import { Box } from '@chakra-ui/react';
import withFlag from '../../../../../helpers/withFlag';

const AIBlock = (props: PluginProps) => {
  const { content } = props;
  const { t } = useTranslation();

  const assistantId = content?.data?.assistant_id;
  const blockId = content?.data?.unique_block_id;

  if (!blockId) {
    return null;
  }

  return (
    <Box height="50vh">
      <Suspense fallback={<div>{t('fallback.loading')}</div>}>
        <PromptContainer assistantId={assistantId} blockId={blockId} />
      </Suspense>
    </Box>
  );
};

export default withFlag(AIBlock, 'new-ai-feature');
